export default "__VITE_ASSET__Dz5Il3DV__"